var map = {
	"./Axe.svg": 7248,
	"./Blade.svg": 5050,
	"./BladeRotate.svg": 4935,
	"./Blunt.svg": 5477,
	"./Bow.svg": 7408,
	"./Chain.svg": 1047,
	"./Improvised.svg": 2752,
	"./Lance.svg": 3617,
	"./Natural.svg": 1231,
	"./Rod.svg": 1955,
	"./Shield.svg": 4271,
	"./Sling.svg": 1079,
	"./Staff.svg": 1502,
	"./Throwing.svg": 1900,
	"./Unarmed.svg": 7890
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9346;